// 导入封装的方法
import {
  post
} from '../http'

const GatheringPublicOpinion = {
  socialopinionrecruitAdd (params) {
    return post('/socialOpinionRecruitPoint/socialopinionrecruit', params)
  }
}
export default GatheringPublicOpinion
